module.exports = __webpack_public_path__ + "img/level3addon_running_gun_shadow.733d06f3.png";